exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.table{font-size:12px}table.table th{color:#242a30!important;background-color:#e9e7e8!important;border:0}table.table td{color:#000;border-color:#cfcdce}table.table tbody{border-bottom:1px solid #cfcdce}table.table thead{border:1px solid #cfcdce}table.table tbody tr{background-color:#fff}table.table tbody td,table.table thead th{padding:8px 12px}table.table thead th:active,table.table thead th:hover{background-color:#edf6fe!important}table.table tbody tr:hover{background-color:#edf6fe}table.table tbody+tbody{border-top:0}.navbar-nav{flex-wrap:wrap}li.nav-item{white-space:nowrap}#app,body,html{height:100%;overflow-y:auto}b{font-weight:700}td.row-fit,th.row-fit{width:1px}.cursor-move{cursor:move}.gap-0{gap:0}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-3{gap:1rem}.gap-4{gap:1.5rem}.gap-5{gap:3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/assets/css/base.scss
// module id = 361
// module chunks = 7